import React, { useEffect, useMemo, useState } from 'react';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import {
    MaterialReactTable,
    useMaterialReactTable,
    type MRT_ColumnDef,
} from 'material-react-table';
// import Image from 'mui-image';
import Breadcrumb from 'src/layouts/full/shared/breadcrumb/Breadcrumb';
import PageContainer from 'src/components/container/PageContainer';
import BlankCard from 'src/components/shared/BlankCard';
import { Course } from 'src/types/course/course';
import axiosServices from 'src/utils/axios';
import { AxiosResponse } from 'axios';
import // IconButton,
    // MenuItem
    '@mui/material';

import {
    //  closeSnackbar,
    useSnackbar,
} from 'notistack';
import Spinner from 'src/views/spinner/Spinner';
import { MenuItem } from '@mui/material';
import { Link } from 'react-router-dom';


const BCrumb = [
    {
        to: '/',
        title: 'Home',
    },
    {
        title: 'Payment',
    },
];

const Payment = () => {

    const { enqueueSnackbar } = useSnackbar();
    const [Payment, setPayment] = useState<Course[]>([]);
    const [loading, setLoading] = useState<boolean>(false);

    const columns = useMemo<MRT_ColumnDef<Course>[]>(
        () => [
            {
                accessorKey: 'id', //access nested data with dot notation
                header: 'id',
                size: 150,
            },

            {
                accessorKey: 'name', //normal accessorKey
                header: 'Student',
                size: 200,
            },
            {
                accessorKey: 'email',
                header: 'Student Email',
                size: 150,
            },
        ],
        [],
    );

    const table = useMaterialReactTable({
        columns,
        data: Payment,
        state: { isLoading: loading },
        positionActionsColumn: 'last',
        enableRowActions: true,
        renderRowActionMenuItems: ({ row }) => [
            <MenuItem key="details">
                <Link to={`/teacher/payment/detail/${row.original.id}`}>Detail</Link>
            </MenuItem>,
        ],
    });

    const getPayment = async () => {
        setLoading(true);
        try {
            const response: AxiosResponse = await axiosServices.get(`/teacher/payment/view`);
            console.log(response, "response")
            setPayment(response.data.data);
            setLoading(false);

        } catch (error: any) {
            setLoading(false);
            if (error.response) {
                // This is an Axios error with a response object
                enqueueSnackbar(error.response.data.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            } else {
                // This is a general error
                enqueueSnackbar(error.message, { variant: 'error' });
                // closeSnackbar(snackbarId);
            }
        }
    };

    useEffect(() => {
        getPayment();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    if (loading) {
        return <Spinner />;
    }

    return (
        <PageContainer title="All Payment " description="All Payment">
            {/* breadcrumb */}
            <Breadcrumb title="Payment" items={BCrumb} />
            <BlankCard>
                {/* ------------------------------------------- */}
                {/* Left part */}
                {/* ------------------------------------------- */}

                <MaterialReactTable table={table} />
            </BlankCard>
        </PageContainer>
    );
};

export default Payment;

